import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { MedicalFeeControlSearchItem } from '../../model/medical-fee/medical-fee-control-search-item';

@Injectable({
  providedIn: 'root'
})
export class MedicalFeeControlService {

  constructor( private dataService: DataService ) { }

  private readonly getMedicalFeeControlSearchItemsEndPoint: string =
          '/medicalFeeControl/getMedicalFeeControlSearchItems/';

  private readonly changeStateEndPoint: string =
          '/medicalFeeControl/changeState/';

  private readonly rollBackChangeStateEndPoint: string =
          '/medicalFeeControl/rollBackChangeState/';

  async rollBackChangeState( valorizationFeeIds: number[] ): Promise<boolean> {

    const params = {
      ValorizationFeeIds: valorizationFeeIds,
    }

    return await this.dataService
    .post<boolean>(this.rollBackChangeStateEndPoint, params)
    .toPromise();
  }

  async getMedicalFeeControlSearchItems( protocol: string, medicalFeeStateIds: number[],
    physicianId?: number, entityId?: number,  planId?: number, from?: Date, to?: Date,
    medicalPreFeeBillId?: number, medicalFeeBillPeriodId?: number, confirmatedFrom?: Date,
     confirmatedTo?: Date, orderByPracticeRegion?: boolean): Promise<MedicalFeeControlSearchItem[]> {

      let toUtc = '';
      let fromUtc = '';

      let confirmatedFromUtc = '';
      let confirmatedToUtc = '';

      if ( confirmatedFrom ) {
        confirmatedFromUtc = new Date(confirmatedFrom.getFullYear(),
        confirmatedFrom.getMonth(), confirmatedFrom.getDate()).toDateString();
      }

      if ( confirmatedTo ) {
        confirmatedToUtc = new Date(confirmatedTo.getFullYear(),
        confirmatedTo.getMonth(), confirmatedTo.getDate()).toDateString();
      }


      if ( from ) {
        fromUtc = new Date(from.getFullYear(),
        from.getMonth(), from.getDate()).toDateString();
      }

      if ( to ) {
        toUtc = new Date(to.getFullYear(),
        to.getMonth(), to.getDate()).toDateString();
      }

    const param = {
      medicalFeeStateIds: JSON.stringify( medicalFeeStateIds ),
      protocol: protocol,
      physicianId: physicianId,
      entityId: entityId,
      planId: planId,
      from: fromUtc,
      to: toUtc,
      medicalPreFeeBillId: medicalPreFeeBillId,
      medicalFeeBillPeriodId: medicalFeeBillPeriodId,
      confirmatedFrom: confirmatedFromUtc,
      confirmatedTo: confirmatedToUtc,
      orderByPracticeRegion,
    };

    return await this.dataService
          .get<MedicalFeeControlSearchItem[]>(this.getMedicalFeeControlSearchItemsEndPoint, param)
          .toPromise();
  }

  async changeState(valorizationFeeIds: number[], medicalFeeStateId: number,
          description: string, noMedicalFeeReasonId?: number) {

    const params = {
      ValorizationFeeIds: valorizationFeeIds,
      MedicalFeeStateId: medicalFeeStateId,
      NoMedicalFeeReasonId: noMedicalFeeReasonId,
      Description: description
    }

    return await this.dataService
    .post<boolean>(this.changeStateEndPoint, params)
    .toPromise();

  }
}
